import SaveIcon from '@mui/icons-material/Save';
import SendIcon from '@mui/icons-material/Send';
import { Box, Button, FormHelperText } from '@mui/material';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import AxiosConfig from '../../../../../../../config/AxiosConfig';
import LoadingButton from '../../../../../utils/common/LoadingButton';

export const RefundFormActions = ({
  ticket,
  isOlderThanSixMonths,
  formState,
  errorFormState,
  mutateTicket,
  handleShowComponent,
}) => {
  const profile = useSelector((state) => state?.login?.profile);
  const [isLoading, setIsLoading] = useState(false);

  const handleSend = async (isDraft) => {
    if (errorFormState?.isError === false) {
      setIsLoading(true);
      const refundDatas = {
        firstName: formState.firstName,
        lastName: formState.lastName,
        email: formState.email,
        ticketId: ticket?._id,
        seller: formState.marketplace,
        type: formState.demand,
        order: formState.orderRef,
        orderedAt: formState.orderedAt,
        paymentMethod: formState.paymentMethod,
        amountTotal: formState.total,
        amountToRefund: formState.refundAmount,
        refundPercentage: formState.refundPercentage,
        description: formState.desc,
        author: profile?._id,
        refundType: formState.selectedType?._id,
        isMP: formState.isMP,
        isDraft: isDraft,
        rib: null,
      };

      if (!isDraft && isOlderThanSixMonths && formState.rib) {
        const file = await handleAttachmentFile(formState.rib);
        refundDatas.rib = file;
      }

      AxiosConfig.create('post', `/refunds/`)
        .call(refundDatas)
        .exit((_res) => {})
        .catch((err) => console.error(err))
        .finally(() => {
          mutateTicket();
          handleShowComponent(null);
          setIsLoading(false);
        });
    }
    setIsLoading(false);
  };

  const handleAttachmentFile = async (file) => {
    return new Promise((resolve, reject) => {
      let fileReader = new FileReader();
      fileReader.onloadend = async (_e) => {
        const content = fileReader.result;
        resolve({
          file: file,
          content: content,
          name: file.name,
          size: file.size,
          mimeType: file.type,
        });
      };
      fileReader.onerror = (error) => {
        console.error(error);
        reject(error);
      };
      fileReader.readAsDataURL(file);
    });
  };

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button
          variant="outlined"
          color="info"
          onClick={() => handleShowComponent(null)}
        >
          Annuler
        </Button>
        <LoadingButton
          isLoading={isLoading}
          variant="outlined"
          color="primary"
          endIcon={<SaveIcon />}
          sx={{ fontWeight: 'bold' }}
          onClick={() => handleSend(true)}
        >
          Sauvegarder
        </LoadingButton>
        <LoadingButton
          isLoading={isLoading}
          variant="contained"
          color="primary"
          endIcon={<SendIcon />}
          sx={{ fontWeight: 'bold' }}
          onClick={() => handleSend(false)}
          disabled={!(errorFormState.isError === false)}
        >
          Envoyer
        </LoadingButton>
      </Box>
      <FormHelperText
        error={!(errorFormState.isError === false)}
        sx={{
          textAlign: 'right',
          width: '100%',
        }}
      >
        {errorFormState.isError === false
          ? ''
          : 'Veuillez vérifier que tous les champs soient valides.'}
      </FormHelperText>
    </>
  );
};
